const state = {
  angularStore:
    [
      {
        id: 1,
        title_en: "TypeScript Fundamentals",
        title_ua: "Основи TypeScript",
        title_es: "Fundamentos de TypeScript",
        regnumber: "TP81113114",
        grade: "950 / 1000",
        examdate: "21.03.2021",
        image: "https://testprovider.com/ru/search-certificate/tp81113114",
      },
      {
        id: 2,
        title_en: "Angular 2.0 Essential",
        title_ua: "Angular 2.0 Базовий",
        title_es: "Angular 2.0 Básico",
        regnumber: "TP75000423",
        grade: "1000 / 1000",
        examdate: "29.07.2021",
        image: "https://testprovider.com/ru/search-certificate/tp75000423",
      },
      {
        id: 3,
        title_en: "Angular 11.0 Essential",
        title_ua: "Angular 11.0 Базовий",
        title_es: "Angular 11.0 Básico",
        regnumber: "TP23149294",
        grade: "1000 / 1000",
        examdate: "16.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp23149294",
      },
      {
        id: 4,
        title_en: "Angular Advanсed",
        title_ua: "Angular Поглиблений",
        title_es: "Angular Avanzado",
        regnumber: "TP01762348",
        grade: "1000 / 1000",
        examdate: "02.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp01762348",
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};